/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PerformanceLevelDescription } from './performanceLevelDescription';

/**
 * Rubric for a task, dimension -> performance level -> criterion
 */
export interface TaskRubricV1 {
  [key: string]: PerformanceLevelDescription;
}
